// extracted by mini-css-extract-plugin
export default {"popoverContent":"FiltersButtonForExplore_popoverContent__WjrAW"};